import { useMutation, useQueryClient } from '@tanstack/react-query';
import { growthKeys } from '@/data/queryKeys';
import { useGrowthQuery } from '@/data/useGrowthQuery';
import { useNotify } from '@/data/notifications';
import { acceptSuggestedCampaign } from '@/features/campaigns/api';
import { fetchCampaignDraft } from '../api-create';

export function useCampaignDraft(suggestionId: string, enabled = true) {
  return useGrowthQuery({
    queryKey: growthKeys.campaigns.draft(suggestionId),
    queryFn: () => fetchCampaignDraft(suggestionId),
    enabled: enabled && Boolean(suggestionId),
  });
}

export function useAcceptCampaignSuggestion() {
  const queryClient = useQueryClient();
  const notify = useNotify();

  return useMutation({
    mutationFn: (suggestionId: string) =>
      acceptSuggestedCampaign({ id: suggestionId, mode: 'review' }),
    onSuccess: () => {
      notify.success('Campaign launch queued');
      void queryClient.invalidateQueries({ queryKey: [...growthKeys.all, 'campaigns'] });
      void queryClient.invalidateQueries({ queryKey: growthKeys.suggestedCampaigns() });
    },
    onError: (e) => notify.error(e),
  });
}

/** @deprecated Use `useAcceptCampaignSuggestion` — live must not call `POST /campaigns/create/`. */
export const useCreateCampaign = useAcceptCampaignSuggestion;
